// Note: Global styles

export const scrollBarPrefixRemoval = {
  /* For Chrome, Safari, and Opera */
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  /* For Firefox */
  scrollbarWidth: 'none',
  /* For IE and Edge */
  '-ms-overflow-style': 'none',
};
